import React from 'react';
import './ContentGrid.scss';
import { FormattedMessage } from '../../localization';

const ContentGrid = ({ className }: { className?: string }) => {
  const copies = [
    {
      id: 'news',
      defaultMessage: 'News'
    },
    {
      id: 'sports',
      defaultMessage: 'Sports'
    },
    {
      id: 'movie',
      defaultMessage: 'Movie'
    },
    {
      id: 'tv_show',
      defaultMessage: 'TV show'
    }
  ];
  return (
    <div className={`content-grid ${className || ''}`}>
      {copies.map((content) => {
        return (
          <div key={content.id} className="content">
            <img src={require(`../../assets/imgs/content_grid/${content.id}.jpg`)} alt="" />
            <span>
              <FormattedMessage id={content.id} defaultMessage={content.defaultMessage} />
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ContentGrid;
